// Lucide Icons Initialization Utility
export const initializeLucideIcons = () => {
  if (window.lucide) {
    window.lucide.createIcons();
  }
};

// Initialize icons after a short delay to ensure DOM is ready
export const initLucideWithDelay = (delay = 100) => {
  setTimeout(() => {
    initializeLucideIcons();
  }, delay);
};

export default initializeLucideIcons;
